import { api } from "../app/api";
import { useAsync } from "../app/useAsync";
import { StatusChip } from "../components/StatusChip";

export function ShopifyConnectionPage() {
  const status = useAsync(api.shopifyStatus, []);
  const conn = useAsync(api.shopifyConnection, []);

  return (
    <>
      <h1>Shopify Connection</h1>
      <p className="page-sub">
        Current Shopify Admin API connection target for the migration platform.
      </p>

      <div className="card" style={{ marginBottom: "1.2rem" }}>
        <h3>Connected Shopify environment</h3>
        {status.loading ? (
          <p className="muted">Checking…</p>
        ) : status.data ? (
          <table>
            <tbody>
              <tr>
                <td>Configured</td>
                <td>
                  {status.data.configured ? (
                    <StatusChip tone="ok" label="Yes" />
                  ) : (
                    <StatusChip tone="warn" label="No" />
                  )}
                </td>
              </tr>
              <tr>
                <td>Store domain</td>
                <td className="muted">{status.data.storeDomain ?? "—"}</td>
              </tr>
              <tr>
                <td>API version</td>
                <td className="muted">{status.data.apiVersion ?? "—"}</td>
              </tr>
              <tr>
                <td>Admin token present</td>
                <td>
                  {status.data.tokenPresent ? (
                    <StatusChip tone="ok" label="Yes" />
                  ) : (
                    <StatusChip tone="warn" label="No" />
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        ) : (
          <p className="muted">{status.error}</p>
        )}
      </div>

      <div className="card">
        <h3>Live connection test</h3>
        {conn.loading ? (
          <p className="muted">Testing…</p>
        ) : conn.data?.connected ? (
          <>
            <StatusChip tone="ok" label="Connected" />
            <p className="muted" style={{ marginTop: 10 }}>
              {conn.data.shopName} · {conn.data.shopDomain} · API{" "}
              {conn.data.apiVersion}
            </p>
          </>
        ) : conn.data && !conn.data.configured ? (
          <StatusChip tone="warn" label="Not configured" />
        ) : (
          <>
            <StatusChip tone="no" label="Failed" />
            <p className="muted" style={{ marginTop: 10 }}>
              {conn.data?.error ?? conn.error}
            </p>
          </>
        )}
      </div>
    </>
  );
}
